import protokolle from "./sessionsProtokolleEinzeln/index.js";
import sessionsProtokolleFilesOnly from "./sessionsProtokolleFilesOnly";

export default {
    sessionsProtokolle: [].concat(protokolle , sessionsProtokolleFilesOnly)
}